export enum SpecialUtilityItemNavType {
  LOGIN = 'login',
  CART = 'cart',
  CONTACT_US = 'contact_us',
  PAY_MY_BILL = 'pay_my_bill',
}
